import { Component, computed, contentChildren, Signal } from '@angular/core';
import { TableHeaderComponent } from '../table-header/table-header.component';

@Component({
    selector: 'app-table-head',
    templateUrl: './table-head.component.html',
    standalone: true
})
export class TableHeadComponent {
    private headers = contentChildren(TableHeaderComponent);
    public gridTemplateColumns: Signal<string> = computed(() => {
        return this.headers()
            .map((header) => `minmax(${header.minWidth()}, ${header.width()})`)
            .join(' ');
    });
}
